module.exports = __webpack_public_path__ + "img/navCards_yjysm.2c9ffcbb.png";